import { render } from "./Bootstrap.vue?vue&type=template&id=bd4c0698"
import script from "./Bootstrap.vue?vue&type=script&lang=js"
export * from "./Bootstrap.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__